var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34.5,
    stroke: "#CEA02B",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6667 46.5003H38.3333V30.7503C38.3333 29.5064 37.2884 28.5003 36 28.5003H31.3333C30.0449 28.5003 29 29.5064 29 30.7503C29 31.9941 30.0449 32.937 31.3333 32.937H33.6667V46.437H31.3333C30.0449 46.437 29 47.4432 29 48.687C29 49.9308 30.0449 50.937 31.3333 50.937H40.6667C41.9551 50.937 43 49.9308 43 48.687C43 47.4432 41.9573 46.5003 40.6667 46.5003ZM36 24.0003C37.933 24.0003 39.5 22.4893 39.5 20.6253C39.5 18.7613 37.9323 17.251 36 17.251C34.0677 17.251 32.5 18.762 32.5 20.626C32.5 22.49 34.067 24.0003 36 24.0003Z",
    fill: "#CEA02B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeInfo);
export default __webpack_public_path__ + "static/media/largeInfo.42c5d71a3b3c13fcd2163e926f224134.svg";
export { ForwardRef as ReactComponent };